let tbContacts = null,
	gridContacts = null,
	gridScreening = null,
	treeContactGroups = null,
	saveContext = '',
	gridCompanyDocs = null,
	lastCompanyDocId = 0,
	lastScreeningItemRow = null,
	deletedCompanyDocList = [],
	contactIBLChanged = false,
	isGroupsLoaded = false,
	requiredSpan = '<span class="pjq-label-required">*</span>';

window.editContact = null;
window.gridContactGroups = null;
window.gridContactRegions = null;
window.gridContactHistory = null;

function ScreeningGradeC(response) {
	LoadContactHistory(jQuery('#edit-contact-history'));
}

function ItemDetailC(response) {
	var rowIds = lastScreeningItemRow.split('|');
	var subgrid = gridScreening.cells(rowIds[0], 0).getSubGrid();
	var subgrid2 = subgrid.cells(rowIds[1], 0).getSubGrid();
	if (null != subgrid2) {
		subgrid.cells(rowIds[1], 0).close();
		subgrid2.clearAll(true);
		subgrid2.loadXML(subgrid.cells(rowIds[1], 0).getValue(), function () {
			subgrid2.setSizes();
			subgrid2.callEvent("onGridReconstructed", []);
			subgrid.setSizes();
			gridScreening.setSizes();

		});
	}

	subgrid.cells(rowIds[1], 0).open();
}

function DeleteCompanyDocC() {
	deletedCompanyDocList.push(lastCompanyDocId);
	gridCompanyDocs.deleteRow(lastCompanyDocId.toString());
	EnableSave(true);
}

function DeleteCompanyDoc(e, id) {
	lastCompanyDocId = parseInt(id);
	showInfoDialogAB('Delete Confirmation', 'Are you sure you want to delete this document?', 'ui-icon-alert', 'delete-company-doc');
	(e || event).cancelBubble = true;
	return false;
}

function CancelEditContact() {
	if (editContact.IsNew) {
		gridMainLastPage = gridMain.currentPage;
		PanteraScript.PanteraScriptService.DeleteContact(pjqSessionId, editContact.ContactId, DeleteContactC, onScriptError);
	}
	else
		CloseEditContact();

	if (settings.IsApprovalRequired && editContact.IsApprovalRequired) {
		InitializeGridMain(gridMainView);
	}

	if (typeof window.initAbEditCallback === 'function') {
		window.initAbEditCallback(false);
	}
}

function DeleteContact() {
	gridMainLastPage = gridMain.currentPage;
	PanteraScript.PanteraScriptService.DeleteContact(pjqSessionId, parseInt(lastContactId), DeleteContactC, onScriptError);
}

function DeleteContactC(response) {
	if (typeof window.initAbEditCallback === 'function') {
		window.initAbEditCallback(false);
	}

	if (editContact && editContact.ContactId > 0 && settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && !settings.IsRO) {
		settings.CountNeedsApproval--;
		tbMain.setListOptionText('view_approval_default', 'view_needs_approval', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
		tbMain.setItemText('view_approval_default', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
	}

	if (jQuery('#divEdit').hasClass('pjq-hidden') || gridContacts.getRowsNum() < 2) {
		CloseEditContact();
		InitializeGridMain(gridMainView);
	}
	else {
		var nextId = '';
		gridContacts.forEachRow(function (id) {
			if (gridContacts.getSelectedRowId() != id)
				nextId = id;
		});
		getContactInfo(parseInt(nextId));
	}
}

function ApproveContact() {
	gridMainLastPage = gridMain.currentPage;
	PanteraScript.PanteraScriptService.ApproveContact(pjqSessionId, parseInt(lastContactId), ApproveContactC, onScriptError);
}

function ApproveContactC(response) {
	settings.CountNeedsApproval = response;
	tbMain.setListOptionText('view_approval_default', 'view_needs_approval', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
	tbMain.setItemText('view_approval_default', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
	InitializeGridMain(gridMainView);
}

function SaveEditContact2C(response) {
	if (typeof window.initAbEditCallback === 'function') {
		window.initAbEditCallback(false);
	}

	if (editContact.ContactId > 0 && settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && !settings.IsRO && !isKeepInApproval) {
		settings.CountNeedsApproval--;
		tbMain.setListOptionText('view_approval_default', 'view_needs_approval', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
		tbMain.setItemText('view_approval_default', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
	}

	editContact.ContactId = parseInt(response.split('|')[0]);
	editContact.ContactCompanyId = parseInt(response.split('|')[1]);
	var wasNew = (parseInt(response.split('|')[2]) == 1);
	if (gridMainView == 'company')
		gridMainLastSelectedRow = response.split('|')[1];
	else if (gridMainView == 'contact')
		gridMainLastSelectedRow = response.split('|')[0];

	if (wasNew && pjqABContext.length > 0) {
		var i, index = -1;
		if (response.split('|')[3].length > 0) {
			var groupsTemp = response.split('|')[3].split(',');
			for (var j = 0; j < groupsTemp.length; j++) {
				for (i = 0; i < selectedGroups.length; i++) {
					if (selectedGroups[i] == parseInt(groupsTemp[j]))
						index = i;
				}

				if (index == -1)
					selectedGroups.push(parseInt(groupsTemp[j]));

			}
		}
		else {
			for (i = 0; i < selectedContacts.length; i++) {
				if (selectedContacts[i] == editContact.ContactId)
					index = i;
			}

			if (index == -1)
				selectedContacts.push(editContact.ContactId);
		}
	}

	if (saveContext == 'save') {
		CloseEditContact();
		InitializeGridMain(gridMainView);
	}
	else if (saveContext == 'switch' || saveContext == 'mirror-groups')
		getContactInfo(editContact.ContactId);
	else {
		var contactId = 0;
		if (saveContext == 'copy')
			contactId = parseInt(gridContacts.getSelectedRowId());

		if (isNaN(contactId))
			contactId = editContact.ContactId;

		getNewContact(editContact.ContactCompanyId, contactId);
	}
}

function getNewContact(contactCompanyId = 0, copyContactId = 0) {
	let postData = {
		contactCompanyId: contactCompanyId,
		copyContactId: copyContactId
	};
	if (copyContactId === 0) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contact'
				},
				{
					endpoint: 'getnewcontactinfo'
				},
			]),
			data: postData,
			isPascal: true
		}).post().done(_.bind(function (data) {
			GetNewContactC(data);
		}, this)).fail(_.bind(function (xhr, err, result) {
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.GET_NEW_CONTACT_AB, {
				data: postData,
				error: err,
				result: result
			});
		}, this));
	}
	else {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: copyContactId
				},
				{
					endpoint: 'copy'
				}
			]),
			isPascal: true
		}).post().done(_.bind(function (data) {
			GetNewContactC(data);
		}, this)).fail(_.bind(function (xhr, err, result) {
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.GET_NEW_CONTACT_AB, {
				data: postData,
				error: err,
				result: result
			});
		}, this));
	}

}

function GetNewContactC(contact) {
	editContact = contact;
	tbMain.enableItem("new");
	InitializeEdit(contact);
	if (!settings.IsRO && !settings.IsDD && tbContacts != null) {
		tbContacts.disableItem('delete');
	}

	if (tbContacts != null) {
		tbContacts.disableItem("new");
		tbContacts.disableItem("copy");
	}

	if (contact.IsNew && jQuery('#edit-business-legalname').val() == '')
		jQuery('#edit-business-legalname').focus();
	else
		jQuery('#edit-contact-name').focus();

	EnableSave(false);
}

function SaveEditContact(context) {
	saveContext = context;
	PanteraScript.PanteraScriptService.CheckContactEmailExists(pjqSessionId, editContact.ContactId, jQuery('#edit-contact-email').val().trim(), SaveEditContactC, onScriptError);
}

var duplicateContactId = 0;

function SaveEditContactC(response) {
	if (response && parseInt(response) > 0) {
		duplicateContactId = parseInt(response);
		showInfoDialogAB('Duplicate Contact', 'Another contact in your Address Book has this email address already.  Do you still want to save this record?', 'ui-icon-alert', 'duplicate-contact');

	}
	else
		SaveEditContact2();
}

var isKeepInApproval = false;

function SaveEditContact2() {
	let errElem = null,
		emailAddress = jQuery('#edit-contact-email').val().trim();
	ClearValidationError('#edit-contact-email');
	if (emailAddress.length > 0 && !PJQ.helpers.validators.validateEmail(emailAddress, !settings.IsForceEmailSingle).success) {
		SetValidationError('#edit-contact-email', 'Email address is invalid.');
		errElem = jQuery('#edit-contact-email');
	}
	else if (emailAddress.length > 0 && settings.IsForceEmailSingle && (emailAddress.indexOf(',') != -1 || emailAddress.indexOf(';') != -1)) {
		SetValidationError('#edit-contact-email', 'Please enter only one Email address.');
		errElem = jQuery('#edit-contact-email');
	}
	else if (emailAddress.length == 0 && jQuery('#edit-contact-email').hasClass('required')) {
		SetValidationError('#edit-contact-email', 'Email address is required.');
		errElem = jQuery('#edit-contact-email');
	}

	if (!validator.element('#edit-contact-phone'))
		errElem = jQuery('#edit-contact-phone');

	if (!validator.element('#edit-contact-zip'))
		errElem = jQuery('#edit-contact-zip');

	if (jQuery('#edit-contact-country').val() == 'US' && !validator.element('#edit-contact-state-us'))
		errElem = jQuery('#edit-contact-state-us');

	if (jQuery('#edit-contact-country').val() == 'CA' && !validator.element('#edit-contact-state-ca'))
		errElem = jQuery('#edit-contact-state-ca');

	if (!validator.element('#edit-contact-name'))
		errElem = jQuery('#edit-contact-name');

	if (!validator.element('#edit-business-legalname'))
		errElem = jQuery('#edit-business-legalname');

	ClearValidationError('#edit-contact-prev-wage');
	if (editContact.IsABRequiredFields && editContact.IsUnionStatusRequired) {

		if ((jQuery('#edit-contact-union:checked').length == 0) &&
			(jQuery('#edit-contact-nonunion:checked').length == 0) &&
			(jQuery('#edit-contact-prev-wage:checked').length == 0)) {
			SetValidationError('#edit-contact-prev-wage', 'Labor status is required.');
			errElem = jQuery("#edit-contact-prev-wage");
		}
	}

	let contactGroupList = [];
	if (settings.ShouldUseOldGroupSelector) {
		if (!isGroupsLoaded || (editContact.IsDirectory && !editContact.IsPrivate && (!settings.IsDocumentClerk || !settings.HasGroupsLinked) && !settings.IsAllowDirectoryEdit)) {
			contactGroupList = null
		}
		else {
			if (settings.GroupLevel <= 1) {
				for (let i = 0; i < gridContactGroups.getRowsNum(); i++) {
					let rId = gridContactGroups.getRowId(i);
					if (gridContactGroups.cells(rId, 0).getValue() === '1' && !isNaN(rId)) {
						contactGroupList.push(parseInt(rId));
					}
				}
			}
			else {
				contactGroupList = _.map(treeContactGroups.getAllChecked().split(','), function (idStr) {
					return parseInt(idStr);
				});
			}
		}
	}
	else {
		contactGroupList = _.map(contactGroupSelector.getGroupsData().selected, function (group) {
			return group.id;
		});
	}

	let groupCount = _.size(contactGroupList);
	if (groupCount > 1 && jQuery('#edit-contact-groups').hasClass('pjq-single-group-choice')) {
		if (null == errElem)
			jQuery("#contact-info-additional").accordion("option", "active", 0);

		if (jQuery('label.pjq-errortext', jQuery('#edit-contact-groups').parent()).length != 0)
			jQuery('label.pjq-errortext', jQuery('#edit-contact-groups').parent()).remove();
		jQuery('#edit-contact-groups').parent().append("<label for='edit-contact-groups' class='pjq-errortext'><br />Please check only one selection.</label>");

		jQuery('#edit-contact-groups').addClass('pjq-errortext');
		if (null == errElem)
			errElem = jQuery('#edit-contact-groups');
	}
	else if (groupCount > 0 && editContact.SubGroupsRestrictChoiceCount > 0 && groupCount > editContact.SubGroupsRestrictChoiceCount && editContact.IsABRequiredFields) {
		if (null == errElem)
			jQuery("#contact-info-additional").accordion("option", "active", 0);

		if (jQuery('label.pjq-errortext', jQuery('#edit-contact-groups').parent()).length != 0)
			jQuery('label.pjq-errortext', jQuery('#edit-contact-groups').parent()).remove();
		jQuery('#edit-contact-groups').parent().append("<label for='edit-contact-groups' class='pjq-errortext'><br />Please check up to " + editContact.SubGroupsRestrictChoiceCount.toString() + " selections.</label>");

		jQuery('#edit-contact-groups').addClass('pjq-errortext');
		if (null == errElem)
			errElem = jQuery('#edit-contact-groups');
	}
	else if (groupCount == 0 && editContact.IsGroupRequired && editContact.IsABRequiredFields) {
		if (null == errElem)
			jQuery("#contact-info-additional").accordion("option", "active", 0);

		if (jQuery('label.pjq-errortext', jQuery('#edit-contact-groups').parent()).length != 0)
			jQuery('label.pjq-errortext', jQuery('#edit-contact-groups').parent()).remove();
		jQuery('#edit-contact-groups').parent().append("<label for='edit-contact-groups' class='pjq-errortext'><br />Please check at least one selection.</label>");

		jQuery('#edit-contact-groups').addClass('pjq-errortext');
		if (null == errElem)
			errElem = jQuery('#edit-contact-groups');
	}
	else {
		jQuery('#edit-contact-groups').removeClass('pjq-errortext');
		jQuery('label.pjq-errortext', jQuery('#edit-contact-groups').parent()).remove();
	}

	let contactRegionList = '';
	if (settings.IsRegionsMapEnabled && window.regionsMapObj) {
		window.regionsMapObj.save();
	}
	else {
		for (var i = 0; i < gridContactRegions.getRowsNum(); i++) {
			var rId = gridContactRegions.getRowId(i);
			if (rId.toString().indexOf('newRow') === -1 && gridContactRegions.cells(rId, 0).getValue() === '1')
				contactRegionList += rId + ',';
		}

		if (contactRegionList.length > 0) {
			contactRegionList = contactRegionList.substring(0, contactRegionList.length - 1);
		}
		else if (contactRegionList.length === 0 && editContact.IsRegionRequired && editContact.IsABRequiredFields) {
			if (null == errElem)
				jQuery("#contact-info-additional").accordion("option", "active", 1);

			if (settings.IsRegionsMapEnabled) {
				if (jQuery('label.pjq-errortext', jQuery('#regionsOuterContainer').parent()).length != 0)
					jQuery('label.pjq-errortext', jQuery('#regionsOuterContainer').parent()).remove();
				jQuery('#regionsOuterContainer').parent().append("<label for='regionsOuterContainer' class='pjq-errortext'><br />Please check at least one selection.</label>");

				if (null == errElem)
					errElem = jQuery('#regionsOuterContainer');
			}
			else {
				if (jQuery('label.pjq-errortext', jQuery('#edit-contact-regions').parent()).length != 0)
					jQuery('label.pjq-errortext', jQuery('#edit-contact-regions').parent()).remove();
				jQuery('#edit-contact-regions').parent().append("<label for='edit-contact-regions' class='pjq-errortext'><br />Please check at least one selection.</label>");
				jQuery('#edit-contact-regions').addClass('pjq-errortext');

				if (null == errElem)
					errElem = jQuery('#edit-contact-regions');
			}
		}
		else {
			if (settings.IsRegionsMapEnabled) {
				jQuery('label.pjq-errortext', jQuery('#regionsOuterContainer').parent()).remove();
			}
			else {
				jQuery('#edit-contact-regions').removeClass('pjq-errortext');
				jQuery('label.pjq-errortext', jQuery('#edit-contact-regions').parent()).remove();
			}
		}
	}

	jQuery('#myAdditionalInfoCompany tbody tr td input.required,#myAdditionalInfoCompany tbody tr td input.date, #myAdditionalInfoCompany tbody tr td span input.required, #myAdditionalInfoCompany tbody tr td select.selectREQ, #myAdditionalInfoCompany tbody tr td div.pjq-required').each(function () {
		var hasError = false;
		if (jQuery(this).prop("tagName") == 'DIV' && jQuery(this).hasClass('pjq-required')) {
			if (jQuery("input[type='checkbox']:checked", this).length == 0) {
				hasError = true;
				jQuery(this).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please check at least one selection.</label>");
				jQuery(this).addClass('pjq-errortext');
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		else if (!validator.element(this)) {
			hasError = true;
		}

		if (hasError) {
			if (null == errElem) {
				var addAccIndex = 0;
				if (!jQuery("#company-info-additional").accordion("option", "active") || jQuery("#company-info-additional").accordion("option", "active") != addAccIndex)
					jQuery("#company-info-additional").accordion("option", "active", addAccIndex);
			}
			errElem = jQuery(this);
		}
	});

	jQuery('#myAdditionalInfo tbody tr td input.required,#myAdditionalInfo tbody tr td input.date, #myAdditionalInfo tbody tr td span input.required, #myAdditionalInfo tbody tr td select.selectREQ, #myAdditionalInfo tbody tr td div.pjq-required').each(function () {
		var hasError = false;
		if (jQuery(this).prop("tagName") == 'DIV' && jQuery(this).hasClass('pjq-required')) {
			if (jQuery("input[type='checkbox']:checked", this).length == 0) {
				hasError = true;
				jQuery(this).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please check at least one selection.</label>");
				jQuery(this).addClass('pjq-errortext');
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		else if (!validator.element(this)) {
			hasError = true;
		}

		if (hasError) {
			if (null == errElem) {
				var addAccIndex = 2;
				if (jQuery("#contact-info-additional").accordion("option", "active") != addAccIndex)
					jQuery("#contact-info-additional").accordion("option", "active", addAccIndex);
			}
			errElem = jQuery(this);
		}
	});

	if (null != errElem) {
		jQuery('html, body').animate({
			scrollTop: errElem.offset().top
		}, 300);
		errElem.focus();
		return false;
	}

	var contactCompanyCustomFieldList = [];
	jQuery("#myAdditionalInfoCompany tbody tr td input[type='text'],#myAdditionalInfoCompany tbody tr td input.date, #myAdditionalInfoCompany tbody tr td span input, #myAdditionalInfoCompany tbody tr td select, #myAdditionalInfoCompany tbody tr td div, #final-approval-level select").each(function () {
		var fieldId = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('_') + 1);
		if (jQuery(this).prop('tagName') === 'SELECT') {
			let field = {
					fieldId: fieldId,
					value: ''
				},
				options = [];
			jQuery('option:selected', jQuery(this)).each(function () {
				options.push(jQuery(this).val());
			});
			field.value = options.join(',');
			contactCompanyCustomFieldList.push(field);
		}
		else if (jQuery(this).prop("tagName") === 'DIV') {
			let field = {
					fieldId: fieldId
				},
				options = [];
			jQuery("input[type='checkbox']:checked", this).each(function () {
				options.push(jQuery(this).val());
			});
			field.value = options.join(',');
			contactCompanyCustomFieldList.push(field);
		}
		else {
			contactCompanyCustomFieldList.push({
				fieldId: fieldId,
				value: jQuery(this).val().replace(/(\||)/g, "")
			});
		}
	});

	let contactCompanyCustomFieldString = _.map(contactCompanyCustomFieldList, function (field) {
		return field.fieldId.toString() + "{|}" + field.value.toString();
	}).join('||||');

	var contactCustomFieldList = [];
	jQuery("#myAdditionalInfo tbody tr td input[type='text'],#myAdditionalInfo tbody tr td input.date, #myAdditionalInfo tbody tr td span input, #myAdditionalInfo tbody tr td select, #myAdditionalInfo tbody tr td div").each(function () {
		var fieldId = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('_') + 1);
		if (jQuery(this).prop('tagName') === 'SELECT') {
			let field = {
					fieldId: fieldId,
					value: ''
				},
				options = [];
			jQuery('option:selected', jQuery(this)).each(function () {
				options.push(jQuery(this).val());
			});
			field.value = options.join(',');
			contactCustomFieldList.push(field);
		}
		else if (jQuery(this).prop("tagName") === 'DIV') {
			let field = {
					fieldId: fieldId
				},
				options = [];
			jQuery("input[type='checkbox']:checked", this).each(function () {
				options.push(jQuery(this).val());
			});
			field.value = options.join(',');
			contactCustomFieldList.push(field);
		}
		else {
			contactCustomFieldList.push({
				fieldId: fieldId,
				value: jQuery(this).val().replace(/(\||)/g, "")
			});
		}
	});
	let contactCustomFieldString = _.map(contactCustomFieldList, function (field) {
		return field.fieldId.toString() + "{|}" + field.value.toString();
	}).join('||||');

	var myState = '';
	if (jQuery('#edit-contact-country').val() == 'CA')
		myState = jQuery('#edit-contact-state-ca').val();
	else
		myState = jQuery('#edit-contact-state-us').val();

	var contactType = "";
	if (jQuery('#contactType').val().length > 0)
		contactType = jQuery('#contactType').val();

	var userTypeId = null;
	if (jQuery('#userType').val().length > 0)
		userTypeId = parseInt(jQuery('#userType').val());

	gridMainLastPage = gridMain.currentPage;
	var isCompanyBlacklisted = (jQuery('#edit-company-isblacklisted').val() == 'true');
	var isBlacklisted = (jQuery('#edit-contact-isblacklisted').val() == 'true');
	isKeepInApproval = false;
	if (saveContext === 'switch' || saveContext === 'mirror-groups' || (PJQ.app.session.get('masterUserId') === 39 && !editContact.IsNew))
		isKeepInApproval = true;
	PanteraScript.PanteraScriptService.UpdateContactInfoAB(pjqSessionId, editContact.ContactId, editContact.ContactCompanyId, jQuery('#edit-business-legalname').val(), contactCompanyCustomFieldString, jQuery('#edit-company-notes').val(), isCompanyBlacklisted, jQuery('#edit-contact-title').val(),
		jQuery('#edit-contact-name').val(), jQuery('#edit-contact-address1').val(), jQuery('#edit-contact-address2').val(), jQuery('#edit-contact-city').val(),
		myState, jQuery('#edit-contact-zip').val(), jQuery('#edit-contact-country').val(), jQuery('#edit-contact-phone').val(),
		jQuery('#edit-contact-ext').val(), jQuery('#edit-contact-fax').val(), jQuery('#edit-contact-cell').val(), jQuery('#edit-contact-email').val(), (jQuery('#edit-contact-union:checked').length > 0), (jQuery('#edit-contact-nonunion:checked').length > 0), (jQuery('#edit-contact-prev-wage:checked').length > 0), (jQuery('#edit-contact-public-sector:checked').length > 0), (jQuery('#edit-contact-private-sector:checked').length > 0), (jQuery('#edit-contact-dbe:checked').length > 0), (jQuery('#edit-contact-dvbe:checked').length > 0), (jQuery('#edit-contact-mbe:checked').length > 0), (jQuery('#edit-contact-sbe:checked').length > 0), (jQuery('#edit-contact-sdvbe:checked').length > 0), (jQuery('#edit-contact-wbe:checked').length > 0),
		contactGroupList.join(','), contactRegionList, contactCustomFieldString, jQuery('#edit-contact-notes').val(), editContact.IsDefaultContact, (jQuery('#edit-contact-isautoselectdisabled').val() == 'true'), isBlacklisted, editContact.CompanyDocContext, deletedCompanyDocList.join(','), contactType, userTypeId, isKeepInApproval, (saveContext == 'mirror-groups'), SaveEditContact2C, false);

	return true;
}

function EnableSave(enabled) {
	if (editContact.ContactId > 0 && settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && !settings.IsRO)
		jQuery('#edit-save, #edit-save2').button('option', 'disabled', false);
	else {
		if (enabled) {
			jQuery('#edit-save, #edit-save2').button('option', 'disabled', false);
		}
		else {
			jQuery('#edit-save, #edit-save2').button('option', 'disabled', true);
		}
	}

	if (typeof calculateCustomFields == 'function') {
		try {
			calculateCustomFields();
		} catch (err) {
		}
	}
	return true;
}

function CloseEditContact() {
	jQuery("#divGrid").removeClass('pjq-hidden');
	jQuery("#divEdit").addClass('pjq-hidden');
}

function treeContactGroupsclick(id) {
	if (parseInt(id) <= 0) {
		if (treeContactGroups.hasChildren(id)) {
			if (treeContactGroups.getOpenState(id) == 1)
				treeContactGroups.closeItem(id);
			else
				treeContactGroups.openItem(id);
		}
		return;
	}
	if (treeContactGroups.isItemChecked(id))
		treeContactGroups.setCheck(id, 0);
	else
		treeContactGroups.setCheck(id, 1);
}

function treeContactGroupsAfterLoad() {
	if (settings.IsRO) {
		var list = treeContactGroups.getAllSubItems(0);
		var items = list.split(",");
		for (var i = 0; i < items.length; i++) {
			treeContactGroups.disableCheckbox(items[i], true);
		}
	}
}

function PJQAddressBookContactEditInitialize(contact) {
	isGroupsLoaded = false;
	//2015-11-02 should always be true for proqual
	contact.IsPrequal = true;
	if (settings.IsDocumentClerk || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_SHOW_PREQUAL_URL)) {
		var prequalURL = window.location.origin + '/default.aspx?' + contact.PrequalSuffix;
		jQuery('#visitPrequalFormAdminContainer').show();
		jQuery('#visitPrequalFormAdminLink').text(prequalURL);
	}
	editContact = contact;
	deletedCompanyDocList = [];
	lastCompanyDocId = 0;


	// Ridgemont
	if (PJQ.app.session.get('masterUserId') === 168022) {
		jQuery('#exportContactInfoPDF').show();
		jQuery('#exportContactInfoExcel').hide();
		jQuery('#exportContactInfoContainer').show();

		jQuery('#exportContactInfoPDF').button().on('click', function () {
			ShowBusy('Loading...', true);
			PanteraScript.PanteraScriptService.GenerateContactInfoExportReport(editContact.ContactCompanyId, pjqSessionId, false, BuildPrequalExportReportC, onScriptError);
		});

		jQuery('#exportContactInfoExcel').button().on('click', function () {
			ShowBusy('Loading...', true);
			PanteraScript.PanteraScriptService.GenerateContactInfoExportReport(editContact.ContactCompanyId, pjqSessionId, true, BuildPrequalExportReportC, onScriptError);
		});
	}
	else if (PJQ.app.session.get('masterUserId') === 39 && editContact.UpdateKey) {
		jQuery('tr.updaterURLRow').show();
		var updaterURL = 'https://app.panteratools.com/updatecontact/' + editContact.UpdateKey;
		jQuery('#updaterURL').text(updaterURL);

	}

	jQuery('#edit-contact-prev-wage-label').text(settings.PrevailingWageLabel);

	var directoryStatusContainer = jQuery('#editDirectoryContactStatusContainer');
	if (editContact.NetworkVerification == 1) {
		directoryStatusContainer.append('<span class="editDirectoryContactStatus"><span class="networkContactPendingVerifiedIcon"></span><span>Pantera Select Contact<span></span>');
	}
	else if (editContact.NetworkVerification == 2) {
		directoryStatusContainer.append('<span class="editDirectoryContactStatus"><span class="networkContactVerifiedIcon"></span><span>Pantera Verified Contact<span></span>');
	}
	else if (editContact.IsDirectory) {
		directoryStatusContainer.append('<span class="editDirectoryContactStatus"><span class="directoryContactIcon"></span><span>Pantera Directory Contact<span></span>');
	}
	if (editContact.IsDirectory && !editContact.IsPrivate) {
		if ((!settings.IsDocumentClerk || !settings.HasGroupsLinked) && !settings.IsAllowDirectoryEdit) {
			jQuery('.pjq-content, #contact-info').find('input, select, textarea').prop('disabled', true);
			jQuery('#myAdditionalInfo').find('input, select, textarea').prop('disabled', false);
			jQuery('.companyStatusItem, .contactStatusItem').addClass('pjq-hidden');
		}
		jQuery('#company-documents').add(jQuery('#company-documents').prev('h3')).hide();
		jQuery('#edit-contact-union').closest('table.pjq-editable-table').hide();
		jQuery('#edit-company-isblacklisted').closest('div[class*="edit-contact"]').find('table.pjq-editable-table').hide();
	}
	else {
		jQuery('.pjq-content, #contact-info').find('input, select, textarea').prop('disabled', false);
		jQuery('.companyStatusItem, .contactStatusItem, #edit-contact-regions-header').removeClass('pjq-hidden');
		jQuery('#company-documents').add(jQuery('#company-documents').prev('h3')).show();
		jQuery('#regionsMapContainer').hide();
		jQuery('#regionsGridContainer').show();
	}
	jQuery('#company-info-additional').find('input, select, textarea').prop('disabled', false);
	jQuery('#contact-info-additional').find('input, select, textarea').prop('disabled', false);

	jQuery('#edit-company-scopesummary').prop('disabled', true);
	isDirty = false;

	if (settings.IsApprovalRequired && editContact.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') != 'view_needs_approval') {
		tbMain.setListOptionSelected('view_approval_default', 'view_needs_approval');
		tbMain.setItemText('view_approval_default', "Needs Approval (" + settings.CountNeedsApproval.toString() + ")");
	}

	gridMainLastSelectedRow = parseInt(gridMain.getSelectedRowId());
	var myURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + editContact.CompanyDocContext + '&sid=' + pjqSessionId;
	var myDropZone = jQuery('#fileupload1');
	if (settings.IsRO)
		myDropZone = null;

	jQuery('#fileupload1').attr('action', myURL);
	jQuery('#fileupload1').fileupload();
	jQuery('#fileupload1').fileupload('option', {
		autoUpload: true,
		url: myURL,
		dropZone: myDropZone
	});
	jQuery('#fileupload1').bind('fileuploadstart', function (e, data) {
		EnableSave(true);
	});

	if (jQuery('#edit-contact-country').val() == 'CA') {
		jQuery('#edit-contact-state-us').addClass('pjq-hidden');
		jQuery('#edit-contact-state-ca').removeClass('pjq-hidden');
		jQuery('#edit-contact-zip').mask("a9a-9a9", {placeholder: ""});
		jQuery('#edit-contact-zip').removeClass('zipcodeUS');
		jQuery('#edit-contact-zip').addClass('zipcodeCA');
	}
	else {
		jQuery('#edit-contact-state-ca').addClass('pjq-hidden');
		jQuery('#edit-contact-state-us').removeClass('pjq-hidden');
		jQuery('#edit-contact-zip').mask("99999", {placeholder: ""});
		jQuery('#edit-contact-zip').addClass('zipcodeUS');
		jQuery('#edit-contact-zip').removeClass('zipcodeCA');
	}

	//Fix for fileupload Button in IE
	jQuery('.fileinput-button').bind('mousedown', function (event) {
		jQuery(this).find('input[type="file"]').trigger('click');
	});

	if (editContact.ContactType.length > 0)
		jQuery('#contactType').val(editContact.ContactType.toLowerCase());

	if (settings.ContactTypes.length > 0) {
		jQuery('#contactType').hide();
		jQuery('#userType').show();

		_.each(settings.ContactTypes, function (type) {
			jQuery('#userType').append("<option value='" + type.UserTypeId.toString() + "' " + (type.IsDefault ? "selected='selected'" : "") + ">" + type.UserTypeName + "</option>");
		});

		if (editContact.UserTypeId)
			jQuery('#userType').val(editContact.UserTypeId.toString());
	}


	gridCompanyDocs = new dhtmlXGridObject('grid-company-documents');
	gridCompanyDocs.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gridCompanyDocs.enableMultiline(true);
	if (!settings.IsPreQual)
		jQuery('#final-approval-level').add(jQuery('#final-approval-level').prev('td')).add(jQuery('#final-approval-level').next('td')).hide();
	else if (editContact.RecentInvite) {
		jQuery('#proqual-request-date').parent().parent().parent().parent().parent().parent().parent().parent().css('width', '100%');
		jQuery('td.proqual-fields').show();
		jQuery('#proqual-request-date').text(editContact.RecentInvite.CreatedOn ? PJQ.helpers.dateHelpers.getDateString(new Date(editContact.RecentInvite.CreatedOn), PJQ.helpers.dateHelpers.dateFormats.DATE) : '');
		jQuery('#proqual-enrolled-date').text(editContact.RecentInvite.ViewedOn ? PJQ.helpers.dateHelpers.getDateString(new Date(editContact.RecentInvite.ViewedOn), PJQ.helpers.dateHelpers.dateFormats.DATE) : '');
		jQuery('#proqual-expires-date').text(editContact.RecentInvite.ExpiresOn ? PJQ.helpers.dateHelpers.getDateString(new Date(editContact.RecentInvite.ExpiresOn), PJQ.helpers.dateHelpers.dateFormats.DATE) : '');
	}
	else {
		jQuery('td.proqual-fields').hide();
	}

	if (settings.IsRO) {
		gridCompanyDocs.setHeader("Filename");
		gridCompanyDocs.setInitWidthsP("100");
		gridCompanyDocs.setColAlign("left");
	}
	else {
		gridCompanyDocs.setHeader("Filename,Delete");
		gridCompanyDocs.setInitWidthsP("90,10");
		gridCompanyDocs.setColAlign("left,center");
	}
	gridCompanyDocs.setSkin(pjqGridTheme);
	jQuery('#grid-company-docs').css('width', '100%');
	gridCompanyDocs.enableAutoHeight(true);
	//gridCompanyDocs.enableAutoWidth(true);
	gridCompanyDocs.attachEvent("onRowSelect", function (id, ind) {
		// pjqDL(gridCompanyDocs.getUserData(id, "EntryId"));
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'files',
				value: gridCompanyDocs.getUserData(id, "EntryId")
			},
			{
				endpoint: 'downloadentryid'
			}
		]), {
			isEndpoint: true,
			isApi2: true
		});
	});

	gridCompanyDocs.init();
	gridCompanyDocs.loadXML(PJQ.helpers.urlHelpers.buildAPIURL(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'contact'
		},
		{
			endpoint: 'getcompanyattachments'
		}
	], [
		{
			parameter: 'contactCompanyId',
			value: editContact.ContactCompanyId.toString()
		}
	]), false, true), function () {

	});

	jQuery("#company-document-files table[role='presentation'] tbody tr,#contact-document-files table[role='presentation'] tbody tr").remove();
	jQuery('#company-document-files div.dropnotice,#contact-document-files div.dropnotice').show();

	jQuery('.pjq-group-label').text(settings.GroupLabel);
	if (editContact.CompanyContactCount > 1)
		jQuery('.mirrorGroups').show();
	else
		jQuery('.mirrorGroups').hide();

	jQuery('.mirrorGroups').text("Mirror " + settings.GroupLabel);
	jQuery('.mirrorGroups').off().on('click', function (event) {
		showInfoDialogAB('Mirror Confirmation', 'Are you sure you want to mirror ' + settings.GroupLabel + ' from this contact to all contacts in this company?', 'ui-icon-alert', 'mirror-groups');
		event.stopPropagation();
	});

	if (editContact.IsABRequiredFields && editContact.IsGroupRequired) {
		jQuery('.pjq-group-label').append(jQuery(requiredSpan).css('margin-left', '5px'));
	}
	jQuery('.pjq-region-label').text(settings.RegionLabel);
	if (editContact.IsABRequiredFields && editContact.IsRegionRequired) {
		jQuery('.pjq-region-label').append(jQuery(requiredSpan).css('margin-left', '5px'));
	}

	jQuery('#company-info-additional, #contact-info-additional').accordion({
		collapsible: true,
		active: false,
		heightStyle: "content",
		autoHeight: false,
		clearStyle: true
	});
	jQuery("#contact-info-additional").on('accordionactivate', function (event, ui) {
		if (jQuery("#contact-info-additional").accordion("option", "active") == 1) {
			if (window.regionsMapObj) {
				window.regionsMapObj.refresh();
			}
		}
	});

	if (!PJQ.app.session.hasPermission('contacts.canViewAttachments')) {
		$('#company-documents-header,#company-documents').hide();
	}

	jQuery('#edit-commands button, #edit-save2, #edit-cancel2').button();

	if (editContact.ContactId > 0 && settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval' && !settings.IsRO && PJQ.app.session.get('masterUserId') !== 39) {
		jQuery('#edit-save, #edit-save2').button('option', 'label', 'Approve Contact');
		EnableSave(true);
	}
	else
		jQuery('#edit-save, #edit-save2').button('option', 'label', 'Save Changes');


	if (!contact.IsPrequal) {
		var prequalIndex = 2;
		if (!contact.CompanyCustomFields || contact.CompanyCustomFields.length == 0)
			prequalIndex = 1;
		jQuery('#company-info-additional').accordion('option', 'disable', prequalIndex);
		jQuery("#prequalFormData").add(jQuery("#prequalFormData").prev('h3')).hide();
	}

	if (!settings.IsHideContactType)
		jQuery('#contactTypeContainer').show();

	jQuery('#edit-commands button, #edit-save2, #edit-cancel2').button();
	jQuery("#edit-contact-phone").mask('(999) 999-9999', {
		placeholder: " "
	});
	jQuery("#edit-contact-fax").mask('(999) 999-9999', {
		placeholder: " "
	});
	jQuery("#edit-contact-cell").mask('(999) 999-9999', {
		placeholder: " "
	});

	jQuery("#contact-info-additional tbody tr td input.pjq-date-field-width, #company-info-additional tbody tr td input.pjq-date-field-width").mask('99/99/9999', {
		placeholder: " "
	});
	jQuery("#contact-info-additional tbody tr td input.pjq-numeric-field-width, #company-info-additional tbody tr td input.pjq-numeric-field-width").each(function () {
		var minVal = 0;
		if (jQuery(this).attr('min'))
			minVal = parseInt(jQuery(this).attr('min'));
		var maxVal = 2147483647;
		if (jQuery(this).attr('max'))
			maxVal = parseInt(jQuery(this).attr('max'));
		jQuery(this).spinner({
			min: minVal,
			max: maxVal,
			step: 1
		});
	});
	jQuery('#contact-info-additional tbody tr td input.pjq-date-field-width,#company-info-additional tbody tr td input.pjq-date-field-width').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: function (name, sender) {
			validator.element('#' + jQuery(sender).attr('id'));
		}
	});
	jQuery("#contact-info-additional select.pjq-choice-field-width, #company-info-additional select.pjq-choice-field-width, #final-approval-level select").each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("option[value='" + x[i] + "']").attr('selected', 'selected');
		}
	});
	jQuery("#contact-info-additional div.pjq-multiple-choice-list, #company-info-additional div.pjq-multiple-choice-list").each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("input[value='" + x[i] + "']").prop('checked', true);
		}
	});

	EnableSave(false);

	jQuery('#edit-history-list').text('').addClass('pjq-hidden');
	//jQuery('#edit-history-loading').removeClass('pjq-hidden');
	gridContactHistory = new dhtmlXGridObject('edit-history-list');
	gridContactHistory.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gridContactHistory.enableMultiline(true);
	gridContactHistory.setSkin(pjqGridTheme);
	jQuery('#edit-history-list').css('width', '110%');
	gridContactHistory.enableAutoWidth(true);
	gridContactHistory.enableAutoHeight(true, 700);
	gridContactHistory.setNoHeader(true);
	gridContactHistory.init();
	gridContactHistory.attachEvent("onRowSelect", function (id, ind) {
		var ps = gridContactHistory.getUserData(id, "ProjectRecordStatus");
		var projectId = parseInt(gridContactHistory.getUserData(id, "ProjectId"));
		if (projectId > 0 && (ps != 'ARCHIVE' && ps != 'DELETED')) {
			window.location.href = '/Default.aspx?tabId=' + settings.ProjectWallAdminTabId.toString() + '&projectid=' + projectId.toString();
		}
	});
	//LoadContactHistory(jQuery('#edit-contact-history'));

	tbContacts = new dhtmlXToolbarObject("toolbar-contacts");
	tbContacts.setSkin("dhx_web");
	tbContacts.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");

	tbContacts.addButton("new", 1, "New Contact", "add_page.gif", "");
	if (settings.IsRO)
		tbContacts.disableItem("new");

	tbContacts.addSeparator("copy_sep", 2);
	tbContacts.addButton("copy", 3, "Copy Contact", "copy.gif", "");
	if (settings.IsRO)
		tbContacts.disableItem("copy");
	tbContacts.addSeparator("set_default_sep", 5);
	tbContacts.addButton("set_default", 6, "Set as Primary", "set_default_contact.gif", "set_default_contactD.gif");
	tbContacts.addSeparator("end_sep", 7);
	tbContacts.disableItem("set_default");
	tbContacts.addSpacer("end_sep");


	if (!settings.IsRO && !settings.IsDD) {
		tbContacts.addSeparator("delete_sep", 10);
		tbContacts.addButton("delete", 11, "Delete Contact", "action_delete.gif", "action_deleteD.gif");
		tbContacts.disableItem("delete");
	}

	tbContacts.attachEvent("onClick", function (id) {

		if (id == 'new' || id == 'copy') {
			tbContacts.disableItem("new");
			var contactId = 0;
			if (id == 'copy')
				contactId = parseInt(gridContacts.getSelectedRowId());

			if (!jQuery('#edit-save').button('option', 'disabled') && !settings.IsRO)
				SaveEditContact(id);
			else
				getNewContact(editContact.ContactCompanyId, contactId);
		}
		else if (id == 'set_default') {
			editContact.IsDefaultContact = true;
			tbContacts.disableItem("set_default");
			tbContacts.disableItem("delete");
			EnableSave(true);
			gridContacts.forEachRow(function (id) {
				if (gridContacts.getUserData(id, "IsPrimaryContact") == 'true') {
					gridContacts.setRowColor(id, '#FFFFFF');
					gridContacts.setRowTextNormal(id);
				}
				else if (id == gridContacts.getSelectedRowId()) {
					jQuery(gridContacts.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');

					gridContacts.setRowTextBold(id);
				}
			});
		}
		else if (id == 'delete') {
			lastContactId = gridContacts.getSelectedRowId();
			var message = 'Are you sure you want to delete this record?';
			if (editContact.HasOwnInvites)
				message = 'WARNING: The contact you are about to delete is associated with a Qualification Package.  If you delete this contact, the Qualification Package and all associated data will also be deleted.  We recommend you change the contact instead of deleting.  Are you sure you still want to delete this contact?';
			showInfoDialogAB('Delete Confirmation', message, 'ui-icon-alert', 'delete-contact');
		}
	});

	gridContacts = new dhtmlXGridObject('grid-contacts');
	gridContacts.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gridContacts.enableMultiline(true);
	gridContacts.setSkin(pjqGridTheme);
	jQuery('#grid-contacts').css('width', '100%');
	gridContacts.enableAutoHeight(true, 250);
	gridContacts.enableAutoWidth(true);
	gridContacts.init();

	gridContacts.attachEvent("onXLE", function (id, state) {
		setTimeout(function () {
			/* 2017-12-29 temporarily disabling
			jQuery('#grid-contacts').width('100%');
			jQuery('#grid-contacts').find('table.obj').width('100%');
			*/
		}, 1);
	});

	gridContacts.attachEvent("onBeforeSelect", function (id, ind) {
		if (!settings.IsRO && (id == -1 || (gridContacts.getUserData(id, 'IsPrimaryContact') != 'true')))
			tbContacts.enableItem("set_default");

		if (!settings.IsDD && !settings.IsRO && (gridContacts.getUserData(id, 'IsPrimaryContact') != 'true' || gridContacts.getRowsNum() == 1))
			tbContacts.enableItem('delete');
		else if (!settings.IsDD && !settings.IsRO) {
			tbContacts.disableItem('delete');
		}

		if (id == -1 || id == editContact.ContactId.toString())
			return true;

		// switching rows saves the current contact, and loads the other.
		if (!jQuery('#edit-save').button('option', 'disabled') && !settings.IsRO) {
			SaveEditContact('switch');
			return true;
		}
		else {
			getContactInfo(parseInt(id));
		}
	});

	var xmlFile = '/DesktopModules/PJQAddressBook/GetCompanyContacts.aspx?sessionid=' + pjqSessionId + '&ccid=' + editContact.ContactCompanyId.toString() + '&x=' + (new Date).getTime();
	if (editContact.ContactId > 0 && settings.IsApprovalRequired && tbMain.getListOptionSelected('view_approval_default') == 'view_needs_approval')
		xmlFile += '&sflt=SELFADD_NEEDS_APPROVAL';

	gridContacts.loadXML(xmlFile, function () {
		gridContacts.forEachRow(function (id) {
			if (gridContacts.getUserData(id, 'IsPrimaryContact') == 'true') {
				jQuery(gridContacts.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');
				gridContacts.setRowTextBold(id);
			}
			if (gridContacts.getUserData(id, 'IsBlacklisted') == 'true')
				gridContacts.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");

		});
		if (gridContacts.rowsBuffer.length > 0) {
			if (editContact.ContactId == 0) {
				gridContacts.addRow('-1', 'New Contact');
				gridContacts.selectRowById('-1');
			}
			else
				gridContacts.selectRowById(editContact.ContactId.toString());
		}
		gridContacts.setSizes();
	});

	jQuery('#divEdit input.pjq-date-field-width').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: function (name, sender) {
			validator.element('#' + jQuery(sender).attr('id'));
		}
	});

	gridScreening = new dhtmlXGridObject('grid-screening');
	gridScreening.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gridScreening.enableMultiline(true);
	gridScreening.setSkin(pjqGridTheme);
	jQuery('#grid-screening').css('width', '100%');
	gridScreening.enableAutoHeight(true);
	gridScreening.enableEditEvents(true, false, false);
	gridScreening.attachEvent("onCellChanged", function (rId, cInd, nValue) {
		if (gridScreening.getUserData(rId, 'IsAllowGrading') == 'true') {
			var dropDownIndicator = "<img src='/ig_common/images/Office2003DropDownSilver.gif' style='float:right;' />";
			jQuery(gridScreening.cells(rId, 4).cell).append(dropDownIndicator);
			var trueValue = nValue.toString();
			if (trueValue.indexOf('|') > -1) {
				var colorPair = trueValue.split('|')[1].split(';');
				gridScreening.setCellTextStyle(rId, cInd, "color:" + colorPair[0] + ";background-color:" + colorPair[1] + ";");
			}
		}


	});
	gridScreening.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
		var trueValue = nValue ? nValue.toString() : '';
		if (trueValue.indexOf('|') > -1) {
			trueValue = trueValue.substring(0, trueValue.indexOf('|'));
		}
		if (stage == 2 && parseInt(trueValue) > 0 && nValue != oValue) {
			EnableSave(true);
			PanteraScript.PanteraScriptService.UpdateScreeningContactCategoryGrade(pjqSessionId, editContact.ContactId, parseInt(rId), parseInt(trueValue), ScreeningGradeC, onScriptError);
		}
		return true;
	});

	//gridScreening.enableAutoWidth(true);
	gridScreening.init();

	dhtmlxEvent(window, "resize", function () {
		jQuery('#grid-contacts, #grid-contacts div table').css('width', '100%');
		jQuery('#grid-contacts div table tbody tr th').css('width', '');
		gridContacts.setSizes();

		jQuery('#grid-screening, #grid-screening div table').css('width', '100%');
		jQuery('#grid-screening div table tbody tr th').css('width', '');
		gridScreening.setSizes();
	});

	gridScreening.attachEvent("onSubGridLoaded", function (sub_grid_obj, rId, rInd) {
		sub_grid_obj.attachEvent("onRowSelect", function (id, ind) {
			gridScreening.setSelectedRow(rId);
			lastScreeningItemRow = rId + '|' + id;
		});
		sub_grid_obj.attachEvent("onEditCell", function (stage2, rId2, cInd2, nValue2, oValue2) {
			gridScreening.setSelectedRow(rId);
			lastScreeningItemRow = rId + '|' + rId2;
		});

		sub_grid_obj.enableAutoWidth(true);
		sub_grid_obj.setSizes();
		gridScreening.setSizes();
		sub_grid_obj.forEachRow(function (id) {
			sub_grid_obj.setCellTextStyle(id, 2, "color:" + sub_grid_obj.getUserData(id, 'ColorCodeText') + ";background-color:" + sub_grid_obj.getUserData(id, 'ColorCodeBackground') + ";");
		});

		sub_grid_obj.attachEvent("onSubGridLoaded", function (sub_grid_obj2, rId2, rInd2) {

			sub_grid_obj2.attachEvent("onRowSelect", function (id, ind) {
				gridScreening.setSelectedRow(rId);
				sub_grid_obj.setSelectedRow(rId2);
				lastScreeningItemRow = rId + '|' + rId2;
			});
			sub_grid_obj2.attachEvent("onEditCell", function (stage3, rId3, cInd3, nValue3, oValue3) {
				gridScreening.setSelectedRow(rId);
				sub_grid_obj.setSelectedRow(rId2);
				lastScreeningItemRow = rId + '|' + rId2;
			});

			sub_grid_obj2.enableMultiline(true);
			sub_grid_obj2.setSizes();
			sub_grid_obj2.callEvent("onGridReconstructed", []);
			sub_grid_obj.setSizes();
			gridScreening.setSizes();

		});

		setTimeout(function () {
			sub_grid_obj.forEachRow(function (id) {
				sub_grid_obj.cells(id, 0).open();
			});
		}, 100);

	});
	if (contact.IsInvites) {
		gridScreening.loadXML('/DesktopModules/PJQAddressBook/GetScreeningItemCategoryGrades.aspx?sessionid=' + pjqSessionId + '&c=' + contact.ContactId.toString() + '&x=' + (new Date).getTime(), function () {
			gridScreening.forEachRow(function (id) {
				gridScreening.setCellTextStyle(id, 2, "color:" + gridScreening.getUserData(id, 'ColorCodeText') + ";background-color:" + gridScreening.getUserData(id, 'ColorCodeBackground') + ";");
			});
			gridScreening.setSizes();
		});
		jQuery('#screening-list').removeClass('pjq-hidden');
	}
	else {
		jQuery('#screening-list').addClass('pjq-hidden');
	}

	initEditContactGroups();

	if (window.location.href.toLowerCase().indexOf('proqualverified') == -1) {
		jQuery('#prequalRequestButton').button().on('click', function () {
			RequestContactPrequalificationHelper(editContact.ContactId);
		});
	}
	else {
		jQuery('#prequalRequestButton').remove();
	}
	jQuery('#exportPrequalButton').button().on('click', function () {
		ShowBusy('Loading...', true);
		PanteraScript.PanteraScriptService.GeneratePrequalExportReport(editContact.ContactCompanyId, pjqSessionId, false, BuildPrequalExportReportC, onScriptError);
	});

	jQuery('#exportPrequalExcelButton').button().on('click', function () {
		ShowBusy('Loading...', true);
		PanteraScript.PanteraScriptService.GeneratePrequalExportReport(editContact.ContactCompanyId, pjqSessionId, true, BuildPrequalExportReportC, onScriptError);
	});

	function BuildPrequalExportReportC(response) {
		HideBusy();
		var rr = jQuery.parseJSON(response);
		TryOpenWindow(window.open(rr.DownloadURL), rr.DownloadURL);
	}

	jQuery('#prequalRequestButton').find('span.ui-button-text').text('Request Prequalfication');
	jQuery('#exportPrequalButton').find('span.ui-button-text').text('Export Prequalification');
	jQuery('#exportPrequalExcelButton').find('span.ui-button-text').text('Export Prequalification to Excel');

	if (PJQ.app.session.hasPermission('prequal.canView')) {
		$(".qualificationTab").removeClass('hidden');
		let prequalContact = new PJQ.models.contacts.Contact({
			id: contact.ContactId
		});
		prequalContact.fetch({
			success: function () {
				let prequal = new PJQ.models.prequal.Prequal({
					contact: prequalContact,
					masterUserId: PJQ.app.session.get('masterUserId')
				});
				prequal.fetch({
					success: function () {
						if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_SHOW_PREQUAL_EDITOR)) {
							PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Dashboard'), $('#prequalFormData'), {
								prequal: prequal
							}, function ($outer) {
								$('#prequalFormData .prequal-export-pdf').click(function () {
									PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
										{
											endpoint: 'contacts',
											value: contact.ContactId
										},
										{
											endpoint: 'prequal'
										},
										{
											endpoint: 'export'
										}
									], [
										{
											parameter: 'masterUserId',
											value: prequal.get('masterUserId') > 0 ? prequal.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
										},
										{
											parameter: 'isExcel',
											value: false
										}
									]));
								});

								$('#prequalFormData .prequal-export-excel').click(function () {
									PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
										{
											endpoint: 'contacts',
											value: contact.ContactId
										},
										{
											endpoint: 'prequal'
										},
										{
											endpoint: 'export'
										}
									], [
										{
											parameter: 'masterUserId',
											value: prequal.get('masterUserId') > 0 ? prequal.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
										},
										{
											parameter: 'isExcel',
											value: true
										}
									]));
								});

								new PJQ.views.prequal.PrequalEditor({
									el: $outer.find('.screening-dashboard-body'),
									isAdmin: true,
									clients: new PJQ.collections.screenings.ScreeningClients(),
									navContainer: $outer.find('.screening-dashboard-nav-extend'),
									preferences: PJQ.app.session.preferences,
									model: prequal,
									canEdit: PJQ.app.session.hasPermission('prequal.canEdit'),
									contact: new PJQ.models.contacts.Contact({
										id: contact.ContactId
									})
								});
							});
						}
						else {
							new PJQ.views.prequal.PrequalViewer({
								el: '#prequalFormData',
								model: prequal
							});
						}
					}
				});
			}
		});
	}

	if (settings.RegionCount == 0 && !settings.IsRegionsMapEnabled) {
		jQuery('#edit-contact-regions-header').addClass('pjq-hidden');
		gridContactRegions = new dhtmlXGridObject('edit-contact-regions');
	}
	else {
		gridContactRegions = new dhtmlXGridObject('edit-contact-regions');
		gridContactRegions.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
		gridContactRegions.setHeader(settings.RegionLabel + ",&nbsp;");
		gridContactRegions.setNoHeader(true);
		gridContactRegions.setInitWidthsP("6,90");
		gridContactRegions.setColAlign("center,left");
		gridContactRegions.setColTypes("ch,ro");
		gridContactRegions.setColSorting("na,na");
		gridContactRegions.enableTooltips("false,true");
		gridContactRegions.enableAutoHeight(true, 300);
		gridContactRegions.setSkin(pjqGridTheme);
		gridContactRegions.attachEvent("onCheck", function (rId, cInd, state) {
			EnableSave(true);
		});
		gridContactRegions.init();
		gridContactRegions.attachEvent("onXLE", function (grid_obj) {
			if (!gridContactRegions.getRowId(0) || gridContactRegions.getRowsNum() == 0) {
				jQuery('#edit-contact-regions').addClass('pjq-hidden');
			}
		});

		gridContactRegions.load('/DesktopModules/PJQAddressBook/GetRegionListContact.aspx?sessionid=' + pjqSessionId + '&c=' + contact.ContactId.toString(), function () {
			if (settings.IsRO) {
				gridContactRegions.forEachRow(function (id) {
					gridContactRegions.cells(id, 0).setDisabled(true);
				});
			}
		});
	}

	if (settings.IsRegionsMapEnabled) {
		InitEditDirectoryContactRegions();
		jQuery('#regionsGridContainer').hide();
		jQuery('#regionsMapContainer').show();
		jQuery('#edit-contact-regions-header').removeClass('pjq-hidden');
	}

	if (settings.IsRO) {
		jQuery('#edit-save, #edit-save2').addClass('pjq-hidden');
		jQuery('input,select,textarea', '#divEdit').prop('disabled', true);
	}

	if (typeof updateAddInfo === 'function')
		updateAddInfo();

	jQuery('#contactType, #userType').on('change', function () {
		EnableSave(true);
	})

	if (editContact.IsDirectory && !editContact.IsPrivate) {
		jQuery('#copyDirectoryContactButton').on('click', function (e) {
			copyDirectoryContact(editContact.ContactCompanyId);
		}).button().show();
	}
	if (window.copyDialog) {
		window.copyDialog.dialog('close');
		EnableSave(true);
	}

	contactAfterInit();
}

function myCountryChanged() {
	if (jQuery('#edit-contact-country').val() == 'CA') {
		jQuery('#edit-contact-state-us').addClass('pjq-hidden');
		jQuery('#edit-contact-state-ca').removeClass('pjq-hidden');
		jQuery('#edit-contact-state-ca').val('');
		jQuery('#edit-contact-zip').val('');
		jQuery('#edit-contact-zip').mask("a9a-9a9");
		jQuery('#edit-contact-zip').removeClass('zipcodeUS');
		jQuery('#edit-contact-zip').addClass('zipcodeCA');
		jQuery('#myStateCA').focus();
	}
	else {
		jQuery('#edit-contact-state-ca').addClass('pjq-hidden');
		jQuery('#edit-contact-state-us').removeClass('pjq-hidden');
		jQuery('#edit-contact-state-us').val('');
		jQuery('#edit-contact-state-us').focus();
		jQuery('#edit-contact-zip').val('');
		jQuery('#edit-contact-zip').mask("99999");
		jQuery('#edit-contact-zip').addClass('zipcodeUS');
		jQuery('#edit-contact-zip').removeClass('zipcodeCA');
	}
}

function EnableCopyNew() {
	tbContacts.enableItem("new");
	tbContacts.enableItem("copy");
}

function CompanyIBLUpdated() {
	if (contactIBLChanged) {
		contactIBLChanged = false;
		return;
	}

	EnableSave(true);
	jQuery('#edit-contact-isblacklisted').val(jQuery('#edit-company-isblacklisted').val());
	PanteraScript.PanteraScriptService.UpdateContactCompanyIsBlacklisted(pjqSessionId, editContact.ContactCompanyId, (jQuery('#edit-company-isblacklisted').val() == 'true'), null, onScriptError);
}

function ContactIBLUpdated() {
	contactIBLChanged = true;
	EnableSave(true);
	//jQuery('#edit-company-isblacklisted').val(jQuery('#edit-contact-isblacklisted').val());
	//PanteraScript.PanteraScriptService.UpdateContactCompanyIsBlacklisted(pjqSessionId, editContact.ContactCompanyId, (jQuery('#edit-company-isblacklisted').val()=='true'), null ,onScriptError);
}

function ChangeMultipleCheckbox(field, valueArray) {
	for (var v = 0; v < valueArray.length; v++) {
		field.find('input[value="' + valueArray[v] + '"]').prop('checked', true);
		field.find('input[value="' + valueArray[v] + '"]').trigger('change');
	}
}

function UpperCaseFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

function FormatCurrencyHelper(value) {
	var parsedValue = value.val().replace("$", "");
	parsedValue = parsedValue.replace(',', "");
	var formattedValue = parsedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	if (formattedValue.trim().length != 0) {
		value.val('$' + formattedValue);
	}
	else {
		value.val('');
	}

}

function FormatCurrencyValueHelper(value) {
	var parsedValue = value.replace("$", "");
	parsedValue = parsedValue.replace(',', "");
	var formattedValue = parsedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	if (formattedValue.trim().length != 0) {
		formattedValue = '$' + formattedValue;
	}
	else {
		formattedValue = '';
	}
	return formattedValue;
}

function FormatPhoneHelper(value, isUnformat) {
	if (typeof value != 'undefined') {
		var phoneFormatted;
		value = value.replace('(', '');
		value = value.replace(')', '');
		value = value.replace('-', '');
		value = value.replace(' ', '');
		if (isUnformat) {
			return value;
		}
		if (value.length != 0) {
			phoneFormatted = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 10);
		}
		else {
			phoneFormatted == '';
		}
		return phoneFormatted;
	}
	else {
		return '';
	}
}

function PopulateFormDates() {
	var today = new Date();
	var lastYear = today.getFullYear() - 1;
	var twoYearsAgo = today.getFullYear() - 2;
	var threeYearsAgo = today.getFullYear() - 3;
	var fullDateLastYear = (today.getMonth() + 1) + "/" + today.getDate() + "/" + lastYear;

	jQuery('.dateLastYear').text(lastYear);
	jQuery('.dateTwoYearsAgo').text(twoYearsAgo);
	jQuery('.dateThreeYearsAgo').text(threeYearsAgo);
	jQuery('.dateLastYearToday').text(fullDateLastYear);
}

function LoadContactHistory(historyType) {
	var url;
	historyType = historyType.val();
	if (historyType == 'project') {
		url = '/DesktopModules/PJQAddressBook/GetContactProjectHistory.aspx?sessionid=' + pjqSessionId + '&c=' + editContact.ContactId.toString() + '&view=' + historyType + '&x=' + (new Date).getTime();
	}
	else {
		url = '/DesktopModules/PJQAddressBook/GetContactHistory.aspx?sessionid=' + pjqSessionId + '&c=' + editContact.ContactId.toString() + '&view=' + historyType + '&x=' + (new Date).getTime();
	}
	jQuery('#edit-history-loading').removeClass('pjq-hidden');
	jQuery('#edit-history-list,#edit-history-first').addClass('pjq-hidden');
	gridContactHistory.loadXML(url, function () {
		jQuery('#edit-history-list').removeClass('pjq-hidden');
		jQuery('#edit-history-loading,#edit-history-first,#load-contact-history').addClass('pjq-hidden');
		if (historyType.value == 'project') {
			jQuery('#history-sent-count').text('Sent: ' + gridContactHistory.getUserData(null, 'SentCount'));
			jQuery('#history-response-count').text(' Resp: ' + gridContactHistory.getUserData(null, 'ResponseCount'));
		}
		gridContactHistory.setSizes();
	});
}

function formatJSONDateDisplay(dateInput) {
	var createdDate = new Date(parseInt(dateInput.substr(6)));
	var createdHours = createdDate.getHours();
	var createdTimeOfDay = 'am';
	if (createdHours >= 12) {
		createdHours -= 12;
		createdTimeOfDay = 'pm';
	}
	if (createdHours == 0) {
		createdHours = 12;
	}
	var createdMinutes = createdDate.getMinutes();
	if (createdMinutes < 10) {
		createdMinutes = "0" + createdMinutes.toString();
	}

	return (createdDate.getMonth() + 1) + "/" + createdDate.getDate() + "/" + createdDate.getFullYear() + ' - ' + createdHours + ":" + createdMinutes + " " + createdTimeOfDay;
}

function copyDirectoryContact(contactId) {
	window.copyDialog = showInfoDialogAB('Copying', 'Copying Directory Contact...', '', 'no-buttons');
	PanteraScript.PanteraScriptService.CopyDirectoryContact(pjqSessionId, contactId, CopyDirectoryContactC, onScriptError);
}

function CopyDirectoryContactC(response) {
	if (response > 0) {
		if (editContact)
			CancelEditContact();
		getContactInfo(response);
	}
	else {
		window.copyDialog.dialog('destroy');
		showInfoDialogAB('Copy Failed', 'Failed to copy this directory contact.  Please contact an administrator.', '', '');
	}
}

function contactAfterInit() {
	//override in portals
}

window.contactGroupSelector = null;

function initEditContactGroups() {
	if (settings.ShouldUseOldGroupSelector) {
		if (settings.GroupCount == 0 && (editContact.IsPrivate || !editContact.IsDirectory)) {
			jQuery('.pjq-group-label').addClass('pjq-hidden');
			if (settings.GroupLevel <= 1)
				gridContactGroups = new dhtmlXGridObject('edit-contact-groups');
			else
				treeContactGroups = new dhtmlXTreeObject("edit-contact-groups", "100%", "100%", 0);
		}
		else {
			if (settings.GroupLevel <= 1 && (!editContact.IsDirectory || settings.HasGroupsLinked || editContact.IsPrivate)) {
				gridContactGroups = new dhtmlXGridObject('edit-contact-groups');
				gridContactGroups.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
				gridContactGroups.setHeader(settings.GroupLabel + ",&nbsp;");
				gridContactGroups.setNoHeader(true);
				gridContactGroups.setInitWidthsP("6,90");
				gridContactGroups.setColAlign("center,left");
				gridContactGroups.setColTypes("ch,ro");
				gridContactGroups.setColSorting("na,na");
				gridContactGroups.enableTooltips("false,true");
				gridContactGroups.enableAutoHeight(true, 300);
				gridContactGroups.setSkin(pjqGridTheme);
				gridContactGroups.attachEvent("onCheck", function (rId, cInd, state) {
					EnableSave(true);
				});
				gridContactGroups.init();

				gridContactGroups.load('/DesktopModules/PJQAddressBook/GetGroupListContact.aspx?sessionid=' + pjqSessionId + '&c=' + editContact.ContactId.toString(), function () {
					if (settings.IsRO) {
						gridContactGroups.forEachRow(function (id) {
							gridContactGroups.cells(id, 0).setDisabled(true);
						});
					}
					isGroupsLoaded = true;
				});
			}
			else {
				treeContactGroups = new dhtmlXTreeObject("edit-contact-groups", "100%", "100%", 0);
				treeContactGroups.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
				treeContactGroups.enableCheckBoxes(1);
				treeContactGroups.enableMultiLineItems("300px");
				treeContactGroups.enableTreeLines(false);
				treeContactGroups.enableTreeImages(false);
				treeContactGroups.setOnClickHandler(treeContactGroupsclick);
				treeContactGroups.setDataMode('json');
				treeContactGroups.attachEvent("onCheck", function (id, state) {
					EnableSave(true);
				});
				treeContactGroups.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTreeContact.aspx?sessionid=' + PJQ.app.session.id + '&c=' + editContact.ContactId.toString(), treeContactGroupsAfterLoad);
				treeContactGroups.attachEvent("onXLE", function (id, state) {
					isGroupsLoaded = true;

					//disable editing if this is a directory contact and groups arent linked or they arent allowed to edit directory contacts
					if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DISABLE_PARENT_GROUPS)) {
						let subItems = treeContactGroups.getAllSubItems('0').split(',');
						for (let i = 0; i < subItems.length; i++) {
							if (subItems[i] < 0)
								treeContactGroups.disableCheckbox(subItems[i], true);
						}
					}
					else if (editContact.IsDirectory && !editContact.IsPrivate && (!settings.IsDocumentClerk || !settings.HasGroupsLinked) && !settings.IsAllowDirectoryEdit) {
						let subItems = treeContactGroups.getAllSubItems('0').split(',');
						for (var i = 0; i < subItems.length; i++) {
							treeContactGroups.disableCheckbox(subItems[i], true);
						}
					}
				});
				treeContactGroups.attachEvent("onCheck", function (id, state) {
					if (treeContactGroups.getLevel(id) == 1) {
						var groupSubItems = treeContactGroups.getAllSubItems(id).split(',');
						for (var i = 0; i < groupSubItems.length; i++) {
							treeContactGroups.setCheck(groupSubItems[i], state);
						}
					}
				})
			}
		}
	}
	else {
		let canEdit = false;
		if (editContact.IsPrivate || settings.IsDocumentClerk || (editContact.IsDirectory && settings.IsAllowDirectoryEdit)) {
			canEdit = true;
		}
		contactGroupSelector = new PJQ.views.groups.GroupSelector({
			el: $('#edit-contact-groups'),
			selectedGroups: new PJQ.collections.groups.Groups(PJQ.helpers.objectHelpers.convertObjectCamelcase(editContact.Groups)),
			contactId: editContact.ContactId,
			isAdmin: !settings.IsDocumentClerk,
			canEdit: canEdit,
			onGroupSelected: function () {
				EnableSave(true);
			}
		});
	}
}

function GetVCard(id) {
	PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'contacts',
			value: id
		},
		{
			endpoint: 'vcard'
		}
	]));
}

function mirrorGroups() {
	SaveEditContact('mirror-groups');
}

function ScreeningItemDownloadAll(sender) {
	let attachments = new PJQ.collections.screenings.ScreeningItemAttachments(null, {
		masterUserId: PJQ.app.session.get('masterUserId'),
		screeningInviteItemId: jQuery(sender).attr('pjq-sii')
	});
	attachments.fetch({
		success: function () {
			attachments.download();
		}
	});
}

function ScreeningExportNotes() {
	PJQ.files.downloadFile(
		PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: editContact.ContactId
			},
			{
				endpoint: 'screenings'
			},
			{
				endpoint: 'notes'
			},
			{
				endpoint: 'export'
			}
		])
	);
}
